import React, { useState, useEffect } from 'react';
import IconValidade from 'assets/images/colored_icons/icon_validade.svg';
import IconRelogio from 'assets/images/colored_icons/icon-relogio.svg';
import IconAssine from 'assets/images/colored_icons/icon_assine.svg';
import IconDoc from 'assets/images/colored_icons/icon_doc.svg';
import { ProportionalSaleTypes } from 'store/modules/proportional_sale_simulation_store/types';
import loadingButton from 'assets/images/loading.gif';
import { useDispatch } from 'react-redux';
import { Container } from './styles';

interface DigitalSignatureSaleProps {
  dados: any;
}

const DigitalSignatureSale = (props: DigitalSignatureSaleProps) => {
  const { dados } = props;
  const dispatch = useDispatch();
  const [digitalSignature, setDigitalSignature] = useState<boolean>(false);

  useEffect(() => {
    document.title = 'Assinatura Digital Documentos - ConLicitação';
  }, []);

  const handleClick = async () => {
    if (dados) {
      setDigitalSignature(true);
      dispatch({
        type: ProportionalSaleTypes.DADOS_PROPORTIONAL_SALE,
        dados,
        servico: [14],
      });
    } else {
      window.location.href = `/contato`;
    }
  };
  return (
    <Container className="w-100">
      <div className={`w-100 ${dados === null ? '' : 'bg-img'}`}>
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12 text-right mt-3" />
          </div>
        </div>
        <div className="container">
          <div className="row  my-5">
            <div className="col-md-6 mt-5">
              <h1 className="font-weight-bold ml-5">
                Assinatura Digital
                <br /> Documentos
              </h1>
              <p className="subtitle ml-5">
                Assine seus documentos a qualquer <br />
                hora e em qualquer lugar.
              </p>
              <button
                type="button"
                className="btn text-center ml-5 contrate"
                onClick={() => handleClick()}
              >
                {digitalSignature && (
                  <img className="mr-2" src={loadingButton} alt="loading" width="25px" />
                )}
                Contrate agora
              </button>
            </div>
            <div className="col-md-6 ">
              <iframe
                width="560"
                height="315"
                src="https://www.youtube.com/embed/2QBf1VgpMV4"
                title="YouTube video player"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              />
            </div>
          </div>
          <div className="row mt-5 p-5">
            <div className="col-xs-12 col-sm-3 col-md-3 col-lg-3">
              <div className="card shadow p-3 border-color-boletim">
                <div className="row">
                  <div className="col-sm-12 text-center p-2 mb-3`">
                    <img
                      className="card-img-top mt-2"
                      src={IconValidade}
                      alt="Calendar"
                      style={{ width: '60px' }}
                    />
                    <p className="info-card mt-4">Validade jurídica</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xs-12 col-sm-3 col-md-3 col-lg-3">
              <div className="card shadow p-3 border-color-boletim">
                <div className="row">
                  <div className="col-sm-12 text-center">
                    <img
                      className="card-img-top mt-2"
                      src={IconDoc}
                      alt="documento"
                      style={{ width: '60px' }}
                    />
                    <p className="info-card mt-3">
                      Qualquer tipo de <br /> documento
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xs-12 col-sm-3 col-md-3 col-lg-3">
              <div className="card shadow p-3 border-color-boletim">
                <div className="row">
                  <div className="col-sm-12 text-center">
                    <img
                      className="card-img-top mt-2"
                      src={IconAssine}
                      alt="assine"
                      style={{ width: '60px' }}
                    />
                    <p className="info-card mt-3">
                      Assine quantos <br /> documentos quiser
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xs-12 col-sm-3 col-md-3 col-lg-3">
              <div className="card shadow p-3 border-color-boletim">
                <div className="row">
                  <div className="col-sm-12 text-center">
                    <img
                      className="card-img-top mt-2"
                      src={IconRelogio}
                      alt="Calendar"
                      style={{ width: '60px' }}
                    />
                    <p className="info-card mt-3">
                      Reduza os custos e <br /> economize tempo
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 text-center mt-5">
              <h3 className="h3-list">Por que contratar o Assinatura Digital de Documentos?</h3>
              <p className="p-desc text-left">
                Com essa ferramenta você consegue assinar digitalmente e com validade jurídica
                qualquer tipo de documento, como contratos, pedidos, controles financeiros,
                procurações, aprovações, acordos, vistorias e muitos outros.
              </p>
              <p className="p-desc text-left">
                Contrate a ferramenta uma única vez e assine quantos documentos quiser durante a
                vigência da sua assinatura!
              </p>
            </div>
          </div>
          <div className="row p-5 mt-5 mb-2 mr-2">
            <div className="col-md-5">
              <h2 className="font-weight-bold">Assine agora</h2>
              <p className="descricao">
                Assine seus documentos <br /> a qualquer hora e em <br /> qualquer lugar.
              </p>
            </div>
            <div className="col-md-7">
              <div className="card card-sale">
                <div className="card-body text-center">
                  <p className="card-text preco-promocao">
                    De
                    <span>
                      <s>R$ 229,00</s>
                    </span>
                    mensais
                  </p>
                  <p className="card-text preco-atual">
                    por
                    <span>R$ 119,00</span>
                    mensais
                  </p>
                  <p className="card-text">
                    valor total{' '}
                    {Number(dados?.data?.valor_base).toLocaleString('pt-br', {
                      style: 'currency',
                      currency: 'BRL',
                    })}{' '}
                    proporcional ao seu plano atual de assinatura
                  </p>
                  <button type="button" className="btn contrate" onClick={() => handleClick()}>
                    {digitalSignature && (
                      <img className="mr-2" src={loadingButton} alt="loading" width="25px" />
                    )}
                    Contrate agora
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default DigitalSignatureSale;
